import { ModalsTest } from "./modals-test";

export const publicRoutes = {
  path: "public",
  children: [
    {
      path: "modals",
      element: <ModalsTest />
    }
  ]
};
